import React, { useEffect, useState } from "react";

import dayjs from "dayjs";
import i18next from "i18next";
import { toast } from "react-toastify";

import { BSCoreServicesDtoMarketplaceFinDataDto } from "api/reactQuery/querySchemas";
import {
  getDistributorFinData,
  getMpDistributors,
} from "components/Actions/distributorsActions";

import Loader from "../Loader";
import BonusOnInvoiceTable from "./components/BonusOnInvoiceTable";
import DistributorSelector from "../DistributorSelector";
import FinancialInfoCards from "./components/FinancialInfoCards";
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the Data Grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the Data Grid

import FinancialInfoTable from "./components/FinancialInfoTable";
import NcpCompensationTable from "./components/NcpCompensationTable";

const FinancialInfo = () => {
  const [distributors, setDistributors] = useState<Distributor[]>();
  const [isLoadingDistributors, setIsLoadingDistributors] = useState(true);
  const [selectedDistributorId, setSelectedDistributorId] = useState<Distributor["id"]>();
  const [distributorFinancialData, setDistributorFinancialData] = useState<BSCoreServicesDtoMarketplaceFinDataDto>();
  const [isLoadingFinancialData, setIsLoadingFinancialData] = useState(true);

  useEffect(() => {
    setIsLoadingDistributors(true);
    getMpDistributors(
      (response) => {
        setDistributors(response);
      },
      (error) => {
        toast.error(error.response.statusText ?? "Error");
      },
      () => {
        setIsLoadingDistributors(false);
      },
    );
  }, []);

  useEffect(() => {
    if (!selectedDistributorId) return;

    setIsLoadingFinancialData(true);

    getDistributorFinData(
      selectedDistributorId,
      (response) => {
        setDistributorFinancialData(
          response as BSCoreServicesDtoMarketplaceFinDataDto,
        );
      },
      (error) => {
        toast.error(error.response.statusText ?? "Error");
      },
      () => {
        setIsLoadingFinancialData(false);
      },
    );
  }, [selectedDistributorId]);

  return (
    <>
      <Loader isLoading={isLoadingDistributors} />

      <DistributorSelector
        distributors={distributors}
        isLoading={isLoadingDistributors}
        setSelectedDistributorId={setSelectedDistributorId}
      />

      {!!distributorFinancialData?.bonusOnInvoiceDetails && (
        <BonusOnInvoiceTable bonusOnInvoiceData={distributorFinancialData.bonusOnInvoiceDetails} />
      )}

      {!!distributorFinancialData?.ncpCompensationDetails && (
        <NcpCompensationTable ncpData={distributorFinancialData.ncpCompensationDetails} />
      )}

      {distributorFinancialData && (
        <h1 style={{ fontSize: 30, marginBottom: 12 }}>
          {i18next.t("financial_information")}
        </h1>
      )}

      <FinancialInfoCards
        isLoadingFinancialData={isLoadingFinancialData}
        distributorFinancialData={distributorFinancialData}
      />

      {distributorFinancialData && (
        <FinancialInfoTable distributorFinancialDataDetails={distributorFinancialData.details} />
      )}

      {distributorFinancialData?.dateOfImport && (
        <div
          style={{
            color: "#6d6d6d",
            fontSize: 12,
            marginTop: 8,
            textAlign: "left",
          }}
        >
          {`${i18next.t("fi_date_of_import")}: ${dayjs(
            distributorFinancialData.dateOfImport,
          ).format("DD.MM.YYYY HH:mm")}`}
        </div>
      )}
    </>
  );
};

export default FinancialInfo;
